import { Col, Row } from "react-bootstrap"
import { getScommesseQuotePronosticiPageUrl } from "../../../utils/urls"
import Link from "next/link"
import { PredictionMatchList } from "@components/Predictions/PredictionMatchList"
import Pagination from "@components/UI/Pagination"
import { GroupStandings } from "@components/Competition/GroupStandings"
import QuotePronosticiSeo from "@components/SeoTextComponents/QuotePronosticiSeo"
import React from "react"
import { useRouter } from "next/router"
import { LocalizedMatchWithSimplifiedNews } from "../../../types/match"
import { TeamBettingParameterStandingFlat } from "../../../types/groupTeamStanding"
import { NavigationCompetition } from "../../../types/competition"
import QuotePronosticiSerieASeo from "@components/SeoTextComponents/QuotePronosticiSerieASeo"
import { orderBy } from "lodash"
import { CompetitionConstants } from "../../../constants/competitions"
import { getPriorityOrderCompetition } from "../../../utils/competition"
import { GroupStandingsWithCompetition } from "@components/Competition/GroupStandingsWithCompetition"
import { CalciocomConfigHomeLocalizedData } from "../../../types/calciocomConfigs"
import QuotePronosticiEuropei from "@components/SeoTextComponents/QuotePronosticiEuropei"
import { LocalizedLanding } from "../../../types/landing"
import { PredictionLandingList } from "@components/Predictions/PredictionLandingList"

type Props = {
  matches: LocalizedMatchWithSimplifiedNews[]
  landings: LocalizedLanding[]
  pageNum: number
  pages: number
  teamStandings: TeamBettingParameterStandingFlat[]
  seasonSlug: string | null
  navigationCompetitions: NavigationCompetition[]
  competitionName: string
  homeData?: CalciocomConfigHomeLocalizedData[]
  competitionHeaderText?: string | null
  competitionSlug: string | null
}
export default function BetNews({
  matches,
  landings,
  pageNum,
  pages,
  teamStandings,
  seasonSlug,
  navigationCompetitions,
  competitionName,
  homeData,
  competitionHeaderText,
  competitionSlug,
}: Props) {
  let headerCompetitions: NavigationCompetition[] = []

  const router = useRouter()

  if (navigationCompetitions) {
    headerCompetitions = [
      ...orderBy(
        navigationCompetitions.filter((c) => {
          return CompetitionConstants.BETTING_COMPETITIONS_IDS.includes(c.id)
        }),
        [getPriorityOrderCompetition, "name"],
      ),
    ]
  }
  headerCompetitions.unshift({
    calciocomSlug: null,
    name: "Tutti",
    id: 9999,
  })

  const defaultHeaderText = (
    <Row>
      <div className={"text-section"}>
        <div className={"text-div"}>
          Prevedere il risultato di una partita è un processo complicato, ma noi di Calcio.com mettiamo a tua
          disposizione i nostri esperti per offrirti i migliori <strong>pronostici sulle scommesse calcio</strong>.
          Attraverso le pagine dedicate ai pronostici, troverai un’ampia serie di <strong>dati gratis</strong> e sempre
          accessibili.
        </div>
      </div>
    </Row>
  )

  let seoHeaderText = defaultHeaderText
  let seoTitle = "Scommesse sul Calcio"

  if (competitionHeaderText !== null) {
    seoHeaderText = competitionHeaderText ? (
      <div className="text-div" dangerouslySetInnerHTML={{ __html: competitionHeaderText as string }} />
    ) : (
      defaultHeaderText
    )
  }

  let seoComponent: JSX.Element = <></>

  switch (competitionName) {
    case "Serie A":
      seoComponent = <QuotePronosticiSerieASeo />
      seoTitle = `sulla ${competitionName}`
      break
    case "UEFA EURO 2024":
      seoComponent = <QuotePronosticiEuropei />
      seoTitle = "su EURO 2024"
      break
    case "Tutti":
      seoComponent = <QuotePronosticiSeo />
      break
    case "Premier League":
      seoTitle = `sulla ${competitionName}`
      break
    case "Ligue 1":
      seoTitle = `sulla ${competitionName}`
      break
    case "LaLiga":
      seoTitle = `su ${competitionName}`
      break
    case "Bundesliga":
      seoTitle = `sulla ${competitionName}`
      break
    default:
      seoHeaderText = <></>
      seoTitle = `sulla ${competitionName}`
      break
  }
  return (
    <div className={"predictions-page paddingZero"}>
      <Row>
        <h1 className="pageTitle">Quote e Pronostici {seoTitle}</h1>
      </Row>
      {seoHeaderText}
      <Row>
        <Col className={"news-type-selector-cc"}>
          <Row className={"main-row g-0 competitionsQuotePageContainer"}>
            {headerCompetitions.map((headerCompetition, i) => {
              return (
                <Col
                  lg={2}
                  sm={3}
                  xs={4}
                  className={"bet-competition"}
                  key={headerCompetition.id}
                  onClick={() => {
                    router.push(getScommesseQuotePronosticiPageUrl(headerCompetition.calciocomSlug))
                  }}
                >
                  <Link
                    href={getScommesseQuotePronosticiPageUrl(headerCompetition.calciocomSlug)}
                    passHref
                    legacyBehavior
                    key={i}
                  >
                    <a>
                      <div
                        className={`type ${
                          competitionSlug === headerCompetition.calciocomSlug ||
                          (competitionSlug == null && headerCompetition.calciocomSlug == null)
                            ? "selected"
                            : ""
                        }`}
                      >
                        {headerCompetition.name}
                      </div>
                    </a>
                  </Link>
                </Col>
              )
            })}
          </Row>
        </Col>
      </Row>
      <Row className="pagina-quote-matchlist">
        {matches.length > 0 ? (
          <PredictionMatchList matchWithNewsList={matches} />
        ) : (
          <PredictionLandingList matchWithNewsList={landings} />
        )}
      </Row>
      <Row className={"page-desktop-row page-mobilegit-row"}>
        <Pagination
          page={pageNum}
          pageCount={pages}
          onChange={(page) => {
            return `${getScommesseQuotePronosticiPageUrl(competitionSlug, page)}`
          }}
        />
      </Row>
      <Row className="justify-content-center">
        <Col className={"bet-margin"}>
          {teamStandings && teamStandings.length > 0 ? (
            homeData ? (
              <GroupStandingsWithCompetition
                headerTitle={"Statistiche per scommesse"}
                competitionCalciocomSlug={homeData[0].competition.calciocomSlug}
                seasonCalciocomSlug={null}
                teamStandings={teamStandings}
                homeData={homeData}
              />
            ) : (
              <GroupStandings
                competitionCalciocomSlug={"italia-serie-a"}
                seasonCalciocomSlug={seasonSlug}
                teamStandings={teamStandings}
              />
            )
          ) : null}
        </Col>
      </Row>
      <Row>{seoComponent}</Row>
    </div>
  )
}
